import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/AboutUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/ContactNow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/CtaBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/HowItWork.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/OurBlog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/OurServices.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/OurTeam.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/OurTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa-v2/src/components/WhyChooseUs.tsx");
